window.updateFreeShippingBar = function (cart) {
    const bar = document.querySelector('.free-shipping-bar');
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold);
    const total = cart.total_price;
    const remaining = threshold - total;
    const percentage = Math.min((total / threshold) * 100, 100);

    const messageEl = bar.querySelector('.free-shipping-message');
    const fillEl = bar.querySelector('.progress-bar-fill');

    if (remaining <= 0) {
      messageEl.textContent = "You’ve unlocked free shipping!";
      messageEl.classList.add("success");
    } else {
      messageEl.textContent = `You're ${(remaining / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })} away from Free Shipping`;
      messageEl.classList.remove("success");
    }

    fillEl.style.width = `${percentage}%`;
  };

  document.addEventListener("DOMContentLoaded", function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => window.updateFreeShippingBar(cart));
  });

  document.addEventListener('cart:updated', function (event) {
    window.updateFreeShippingBar(event.detail.cart);
  });